import React from 'react';
import { Box, Typography } from '@mui/material';

const OrDivider = ({ sx }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      my: 2.5,
      ...sx,
    }}
  >
    <Box sx={{ flex: 1, height: '1px', bgcolor: 'divider' }} />
    <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500, px: 0.5 }}>
      or
    </Typography>
    <Box sx={{ flex: 1, height: '1px', bgcolor: 'divider' }} />
  </Box>
);

export default OrDivider;
